"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const GridColumnDataDisplayedType_1 = require("../GridColumnDataDisplayedType");
class IconRenderer {
    render(ctx, icons) {
        const iconContainer = new fmko_ts_widgets_1.Div();
        iconContainer.addCssClass("icon-container");
        for (const icon of icons) {
            iconContainer.add(icon);
        }
        ctx.setWidget(iconContainer);
        ctx.setColumnDataDisplayType(GridColumnDataDisplayedType_1.GridColumnDataDisplayedType.ICON);
    }
    canRender(o) {
        return true;
    }
}
exports.default = IconRenderer;
//# sourceMappingURL=IconRenderer.js.map